import { UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';

import { featureEnabler } from '../../../../utils/feature-enabler';

const supportedTypes = [UIDAPresentationTypeEnum.collection, UIDAPresentationTypeEnum.series_catch_up];
const subtypeFeatures: Partial<Record<UIDAPresentationTypeEnum, () => boolean>> = {
  [UIDAPresentationTypeEnum.series_catch_up]: () => featureEnabler.variation('IS_NEW_SERIES_COLLECTION'),
  [UIDAPresentationTypeEnum.collection]: () => featureEnabler.variation('IS_NEW_COLLECTION_GRID'),
};

export function isNewSubtypeSupported(subtype: UIDAPresentationTypeEnum) {
  const isEnabled = subtypeFeatures[subtype];

  return supportedTypes.includes(subtype) && isEnabled && isEnabled();
}
